import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type ConversationViewModel } from '@/features/messaging/ConversationViewModel'
import { ConversationComposer } from '@/features/messaging/components/ConversationView/ConversationComposer'

export interface ConversationComposerContainerProps {
  vm: ConversationViewModel
  /** @see ConversationComposerProps.leadingActions */
  leadingActions?: ReactNode
  /** @see ConversationComposerProps.trailingActions */
  trailingActions?: ReactNode
}

export const ConversationComposerContainer = observer(
  function ConversationComposerContainer({
    vm,
    leadingActions,
    trailingActions,
  }: ConversationComposerContainerProps) {
    return (
      <ConversationComposer
        leadingActions={leadingActions}
        canToggleNoteMode={vm.canToggleNoteMode}
        trailingActions={trailingActions}
        isNoteModeEnabled={vm.isNoteModeEnabled}
        onToggleNoteMode={vm.noteMode.toggle}
        composerText={vm.composerText}
        onComposerTextChange={vm.setComposerText}
        onSend={vm.sendMessage}
      />
    )
  },
)
